import AgentForm from "./AgentForm";
import "../css/register.agent.css";
import { useAgent } from "../../../contexts/AgentsContext";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const RegisterAgent = () => {
  const {
    clearOngoingAgentData,
    fetchAgentBFs,
    fetchAgentProviders,
    fetchAgentLLMs,
    fetchAgentIndustries,
    fetchAgentSectors,
  } = useAgent();

  const location = useLocation();

  useEffect(() => {
    clearOngoingAgentData();

    Promise.allSettled([
      fetchAgentBFs(),
      fetchAgentProviders(),
      fetchAgentLLMs(),
      fetchAgentIndustries(),
      fetchAgentSectors(),
    ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  return (
    <>
      <AgentForm title="Register Agent" type="register" />
    </>
  );
};

export default RegisterAgent;
